<template>
  <div class="transactionRecordCon">
    <div class="userTitle1">
      <span class="iconfont iconjilu">
        <svg
          width="20"
          height="20"
          viewBox="0 0 35 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M33.0639 5.74994H30.1888V8.62491H31.6264V31.6249H20.1259V43.1249H2.87512V8.62486H4.3127V5.74989H1.43758C0.64691 5.74989 0 6.39675 0 7.18742V44.5625C0 45.3531 0.646959 46 1.43758 46H24.0792L34.5016 35.5781V7.18747C34.5016 6.39685 33.8546 5.74994 33.064 5.74994H33.0639ZM23.001 43.125V34.5H31.6263L23.001 43.125ZM28.7513 5.74994H23.001V2.87497C23.001 1.29372 21.7073 0 20.1259 0H14.3757C12.7942 0 11.5006 1.29372 11.5006 2.87497V5.74994H5.75033V11.5H28.7514V5.74994H28.7513ZM20.1259 5.74994H14.3756V2.88011C14.3772 2.87833 14.3788 2.8765 14.3808 2.87492H20.1205C20.1226 2.8765 20.1244 2.87828 20.1259 2.88011V5.74994H20.1259ZM19.3987 23.6643H22.9299L22.9356 21.3358H20.6071L24.4072 14.3361H20.4354L17.8194 20.1294L16.7162 20.1343L14.0397 14.3362H10.0683L13.8484 21.3359H11.4904V23.6657H14.9961L15.3387 24.3763V25.505H11.4905V27.834H15.3387V31.2171H19.0626V27.834H22.9357L22.9355 25.505H19.0636V24.3763L19.3988 23.6642L19.3987 23.6643Z"
            fill="#fff"
          />
        </svg>
      </span>
      交易记录
      <div class="switch-wrapper">
        <span
          v-for="(name, index) in titleBtnArr"
          :key="index"
          :class="titleBtnIndex == index ? 'active' : ''"
          @click="onTables(index)"
        >{{ name }}</span>
        <span v-if="interestShow" @click="interestSwitch">利息宝记录</span>
      </div>
    </div>
    <div class="select-con">
      <el-col :span="1" v-if="titleBtnIndex == 0">游戏平台:</el-col>
      <el-col :span="3" v-if="titleBtnIndex == 0">
        <el-select
          popper-class="userSelect"
          size="medium"
          v-model="form.region"
          placeholder="请选择"
          @visible-change="changes"
        >
          <el-option
            v-for="(item, index) in gameList"
            :label="item.vendorName"
            :value="item.vendorCode"
            :key="index"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="1">时间筛选:</el-col>
      <el-col :span="3">
        <el-date-picker
          type="date"
          placeholder="年/月/日"
          v-model="form.startTimeBet"
          :editable="false"
          :clearable="false"
          style="width: 100%; cursor: pointer"
        ></el-date-picker>
      </el-col>
      <el-col class="line" :span="1">至</el-col>
      <el-col :span="3">
        <el-date-picker
          type="date"
          placeholder="年/月/日"
          v-model="form.endTimeBet"
          :editable="false"
          :clearable="false"
          style="width: 100%"
        ></el-date-picker>
      </el-col>
      <el-col :span="1" :offset="3">
        <el-button @click="getListData()" class="con-btn">查询</el-button>
      </el-col>
      <el-col :span="1">
        <el-button @click="reset()" class="con-btn">重置</el-button>
      </el-col>
    </div>
    <div v-if="titleBtnIndex == 0">
      <el-table :data="tableData" class="myTable" height="650">
        <el-table-column prop="betNo" label="单号" align="center" width="200"></el-table-column>
        <el-table-column prop="vendorName" label="游戏平台" align="center" width="128"></el-table-column>
        <el-table-column prop="gameName" label="游戏名称" align="center" width="128"></el-table-column>
        <el-table-column prop="createdAt" label="投注时间" align="center" width="150"></el-table-column>
        <el-table-column prop="payoutTime" label="派彩时间" align="center" width="150">
          <template
            slot-scope="scope"
          >{{ scope.row['status'] != 0 ? scope.row['payoutTime'] : '-' }}</template>
        </el-table-column>
        <el-table-column prop="betAmountValid" label="投注金额" align="center" width="150"></el-table-column>
        <el-table-column prop="betAmountValid" label="有效投注" align="center" width="150"></el-table-column>
        <el-table-column prop="payoff" label="派彩金额" align="center" width="150">
          <template slot-scope="scope">{{ scope.row['status'] != 0 ? scope.row['payoff'] : '-' }}</template>
        </el-table-column>
        <el-table-column prop="winLoss" label="盈亏金额" align="center" width="128">
          <template slot-scope="scope">{{ scope.row['status'] != 0 ? scope.row['winLoss'] : '-' }}</template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="titleBtnIndex != 0">
      <el-table :data="tableData" class="myTable" height="650">
        <el-table-column prop="orderNo" label="订单号" align="center" width="200"></el-table-column>
        <el-table-column prop="createdAt" label="交易时间" align="center" width="200"></el-table-column>
        <el-table-column prop="payChannel" :label="typeOrMode" align="center" width="200"></el-table-column>
        <el-table-column prop="amount" label="金额" align="center" width="200"></el-table-column>
        <el-table-column label="状态" align="center" width="200">
          <template slot-scope="scope">
            <span
              :class="{
                statusColor:
                  (typeOrMode === '支付方式' &&
                    scope.row.status !== '支付成功') ||
                  (typeOrMode === '提款方式' &&
                    scope.row.status !== '出款成功') ||
                  (typeOrMode === '类型' && scope.row.status !== '成功'),
              }"
            >{{ scope.row.status }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="combined">
      <div>
        <div v-show="titleBtnIndex === 0">
          <span>总投注:￥{{ totalBet }}</span>
          <span>总有效投注:￥{{ effective }}</span>
          <span>总派彩:￥{{ distributed }}</span>
          <span>总盈亏金额:￥{{ profit }}</span>
        </div>
      </div>
      <div class="paginationRight">
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          :page-size="15"
          @current-change="handleCurrentChange"
          :current-page.sync="resetVal"
          style="float: right"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      totalBet: "",
      effective: "",
      distributed: "",
      profit: "",
      titleBtnArr: ["游戏记录", "充值记录", "提现记录"],
      titleBtnIndex: 0,
      tableData: [],
      total: 0,
      resetVal: 1,
      currentPage: 0,
      typeOrMode: "",
      form: {
        betAmountMin: "",
        betAmountMax: "",
        startTimeBet: "",
        endTimeBet: "",
        pageSize: 15,
        pageNum: 1,
        region: "",
        vendorCodeList: [],
        memberId: this.$common.getUser() ? this.$common.getUser().user_id : "",
      },
      form2: {
        startTime: "",
        endTime: "",
        fixedStartTime: "",
        fixedEndTime: "",
        pageSize: 15,
        memberId: this.$common.getUser() ? this.$common.getUser().user_id : "",
      },
      gameList: [],
      apiUrl: this.$api.query,
      interestShow: false,
    };
  },
  mounted() {
    this.getGameListData();
    this.getListData();
    this.interest();
  },
  methods: {
    // 利息宝显示隐藏
    interest() {
      this.$http
        .get(this.$api.getSettings, "interest_global_status")
        .then((res) => {
          if (res) {
            console.log("-----利息宝返回-----", res);
            if (res.data.svalue) {
              if (res.data.svalue.interest_global_status === 0) {
                this.interestShow = false;
              } else {
                this.interestShow = true;
                // this.availableAmount()
              }
            } else {
              this.interestShow = false;
            }
            // 设置本地缓存
            // console.log('------设置本地缓存-------')
            // window.localStorage.setItem('allPeopleBack',this.rebateShow)
          }
        });
    },
    interestSwitch() {
      this.$parent.$parent.$refs.treasure.itemRecordInfo = {};
      this.$parent.$parent.$refs.treasure.recordVisible = true;
    },
    onTables(index) {
      this.titleBtnIndex = index;
      this.reset();
      switch (index) {
        case 0:
          //游戏记录
          this.apiUrl = this.$api.query;
          break;
        case 1:
          //充值记录
          this.apiUrl = this.$api.pcOnlinePayRecordsList;
          break;
        case 2:
          //提现记录
          this.apiUrl = this.$api.withdrawalsRecords;
          break;
      }
      this.getListData(1);
    },
    handleCurrentChange(index) {
      this.currentPage = index;
      this.getListData(index);
    },
    //获取游戏平台列表数据
    getGameListData() {
      if (this.$store.state.token) {
        this.$http.get(this.$api.platform).then((res) => {
          if (res) {
            this.gameList = res.data;
            this.gameList.unshift({
              vendorCode: "捕鱼",
              vendorId: 9999,
              vendorName: "捕鱼",
            });
          }
        });
      }
    },
    reset() {
      this.currentPage = 1;
      this.form.region = "";
      this.form.vendorCodeList = [];
      this.form.endTimeBet = "";
      this.form.startTimeBet = "";
    },
    changes() {
      this.form.vendorCodeList = [];
    },
    // 查询列表数据
    getListData(val = 1) {
      this.resetVal = val;
      if (this.titleBtnIndex == 0) {
        var _form = this.form;
        _form.pageNum = val;
        _form.startTimeBet
          ? (_form.startTimeBet = this.format(
            _form.startTimeBet,
            "yyyy-MM-dd HH:mm:ss"
          ))
          : (_form.startTimeBet = "");
        _form.endTimeBet
          ? (_form.endTimeBet = this.format(
            _form.endTimeBet,
            "yyyy-MM-dd 23:59:59"
          ))
          : (_form.endTimeBet = "");
        _form.region
          ? _form.vendorCodeList.push(_form.region)
          : _form.vendorCodeList.push();
      } else {
        var _form = this.form2;
        _form.currentPage = val;
        this.form.startTimeBet
          ? (_form.startTime = this.format(
            this.form.startTimeBet,
            "yyyy-MM-dd HH:mm:ss"
          ))
          : (_form.startTime = "");
        this.form.endTimeBet
          ? (_form.endTime = this.format(
            this.form.endTimeBet,
            "yyyy-MM-dd 23:59:59"
          ))
          : (_form.endTime = "");
      }
      this.$nkhttp.http(this.apiUrl, _form, "post", (res) => {
        if (res) {
          if (this.titleBtnIndex == 0) {
            res.list.map((item) => {
              item.betAmountValid = this.$common.setNumFixed(
                item.betAmountValid,
                2
              );
              item.payoff = this.$common.setNumFixed(item.payoff, 2);
              item.winLoss = this.$common.setNumFixed(item.winLoss, 2);
              item.createdAt = this.conversionTime(item.betTime);
              item.payoutTime = this.conversionTime(item.payoutTime);
              item.winLoss == null ? (item.winLoss = 0) : item.winLoss;
              if (item.status == 0) {
                item.payoff = "--";
                item.winLoss = "--";
              }
            });
            this.totalBet = this.$common.setNumFixed(
              Math.abs(res.totalBetAmount),
              2
            );
            this.effective = this.$common.setNumFixed(
              res.totalBetAmountValid,
              2
            );
            this.distributed = this.$common.setNumFixed(res.totalPayoff, 2);
            this.profit = this.$common.setNumFixed(
              this.distributed - this.totalBet,
              2
            );
            this.total = res.total;
            this.tableData = res.list;
            this.typeOrMode = "";
          } else if (this.titleBtnIndex == 1) {
            res.content.map((item) => {
              item.amount = this.$common.setNumFixed(item.amount, 2);
              item.betNo = item.orderNo;
              item.createdAt = this.conversionTime(item.createdAt);
              if (item.type === 41) {
                switch (item.status) {
                  case 0:
                    item.status = "未处理";
                    break;
                  case 1:
                  case 5:
                  case 6:
                  case 7:
                    item.status = "处理中";
                    break;
                  case 2:
                    item.status = "充值成功";
                    break;
                  case 3:
                    item.status = "充值失败";
                    break;
                  case 4:
                    item.status = "关闭";
                    break;
                }
              } else {
                switch (item.status) {
                  case 0:
                    item.status = "待支付";
                    break;
                  case 1:
                    item.status = "支付中";
                    break;
                  case 2:
                    item.status = "支付成功";
                    break;
                  case 3:
                    item.status = "支付失败";
                    break;
                  case 4:
                    item.status = "已关闭";
                    break;
                }
              }
              switch (item.type) {
                case 3:
                  item.payChannel = "线下银行卡支付";
                  break;
                case 4:
                  item.payChannel = "线下二维码支付";
                  break;
                case 5:
                  item.payChannel = "线上支付";
                  break;
                case 11:
                  item.payChannel = "手动上分";
                  break;
                case 41:
                  item.payChannel = "数值货币支付";
                  break;
              }
            });
            this.typeOrMode = "支付方式";
            this.tableData = res.content;
            this.total = res.totalRecords;
          } else {
            res.content.map((item) => {
              item.betNo = item.orderNo;
              item.amount = this.$common.setNumFixed(item.amount, 2);
              item.createdAt = this.conversionTime(item.createdAt);
              if (item.type === 43) {
                switch (item.status) {
                  case 0:
                    item.status = "未处理";
                    break;
                  case 1:
                  case 5:
                  case 6:
                  case 7:
                    item.status = "处理中";
                    break;
                  case 2:
                    item.status = "提款成功";
                    break;
                  case 3:
                    item.status = "提款失败";
                    break;
                  case 4:
                    item.status = "关闭";
                    break;
                }
              } else {
                switch (item.status) {
                  case 0:
                    item.status = "待出款";
                    break;
                  case 1:
                    item.status = "出款中";
                    break;
                  case 2:
                    item.status = "出款成功";
                    break;
                  case 3:
                    item.status = "出款失败";
                    break;
                  case 4:
                    item.status = "关闭";
                    break;
                }
              }
              switch (item.type) {
                case 8:
                  item.payChannel = "银行卡提款";
                  break;
                case 10:
                  item.payChannel = "手动下分";
                  break;
                case 43:
                  item.payChannel = "数值货币提款申请";
                  break;
                case 47:
                  item.payChannel = "起点钱包提款";
                  break;
              }
            });
            this.typeOrMode = "提款方式";
            this.tableData = res.content;
            this.total = res.totalRecords;
          }
        } else {
          this.tableData = [];
          this.total = 0;
        }
      });
    },
    conversionTime(timeStamp) {
      if (timeStamp > 0) {
        var date = new Date();
        date.setTime(timeStamp);
        var y = date.getFullYear();
        var m = date.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        var d = date.getDate();
        d = d < 10 ? "0" + d : d;
        var h = date.getHours();
        h = h < 10 ? "0" + h : h;
        var minute = date.getMinutes();
        var second = date.getSeconds();
        minute = minute < 10 ? "0" + minute : minute;
        second = second < 10 ? "0" + second : second;
        return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
      } else {
        return "";
      }
    },
    format(time, format) {
      var t = new Date(time);
      var tf = function (i) {
        return (i < 10 ? "0" : "") + i;
      };
      return format.replace(/yyyy|MM|dd|HH|mm|ss/g, function (a) {
        switch (a) {
          case "yyyy":
            return tf(t.getFullYear());
            break;
          case "MM":
            return tf(t.getMonth() + 1);
            break;
          case "mm":
            return tf(t.getMinutes());
            break;
          case "dd":
            return tf(t.getDate());
            break;
          case "HH":
            return tf(t.getHours());
            break;
          case "ss":
            return tf(t.getSeconds());
            break;
        }
      });
    },
  },
};
</script>

<style>
.transactionRecordCon {
  width: 100%;
  height: 100%;
}

.switch-wrapper {
  height: 32px;
  margin-left: 30px;
  margin-right: 30px;
  margin-top: 10px;
  width: calc(100% - 60px);
}

.switch-wrapper > span {
  cursor: pointer;
  font-size: 12px;
  display: inline-block;
  width: 100px;
  height: 30px;
  border: 1px solid #ddd;
  margin-right: 30px;
  text-align: center;
  line-height: 30px;
}

.active {
  color: #fff;
  background-color: #333;
  border: 1px solid #333;
}

.select-con {
  font-size: 12px;
  color: #4c4a4a;
  background: #fafafa;
  text-align: center;
  line-height: 44px;
  min-height: 44px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  padding-left: 20px;
  padding-right: 20px;
}

.con-btn {
  text-align: center;
  width: 60px;
  height: 30px;
  line-height: 30px;
  border: 1px solid #e6e6e6;
  background-color: #f2f2f2;
  color: #4c4a4a;
  cursor: pointer;
  padding: 0;
}

.el-input--medium .el-input__inner {
  height: 30px;
}

.el-input__inner {
  height: 30px;
  border: 1px solid #d9c2bf;
}
.statusColor {
  color: red;
  width: 100%;
}
.combined {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}
.combined div {
  margin-left: 20px;
}
.combined .paginationRight {
  margin-right: 20px;
}
.combined span {
  margin-right: 20px;
}
</style>
